import React, { useState, useEffect } from "react";
import { getAuth, updatePassword } from "firebase/auth";
import { doc, getDoc, updateDoc, getFirestore } from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/styles/ClientShared.css";

const MyAccount = () => {
  const [userDetails, setUserDetails] = useState({ firstName: '', lastName: '', email: '', description: '' });
  const [isEditing, setIsEditing] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (auth.currentUser) {
          const userDoc = doc(db, "users", auth.currentUser.uid);
          const docSnap = await getDoc(userDoc);
          if (docSnap.exists()) {
            setUserDetails(docSnap.data());
          } else {
            console.log("No such document!");
          }
        }
      } catch (error) {
        toast.error("Failed to fetch user data.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [auth, db]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleSave = async () => {
    try {
      if (auth.currentUser) {
        const userDoc = doc(db, "users", auth.currentUser.uid);
        await updateDoc(userDoc, { ...userDetails });
        setIsEditing(false);
        toast.success("Profile updated successfully!");
      }
    } catch (error) {
      toast.error("Failed to update profile. Please try again.");
    }
  };

  const handlePasswordChange = async () => {
    try {
      if (!password) {
        toast.error("Password cannot be empty.");
        return;
      }
      await updatePassword(auth.currentUser, password);
      toast.success("Password updated successfully!");
      setPassword("");
    } catch (error) {
      toast.error("Failed to update password. Please try again.");
    }
  };

  if (loading) return <div className="cp-loading"><p>Loading...</p></div>;

  return (
    <div className="cp-page cp-page--narrow">
      <ToastContainer />
      <div className="cp-page-header">
        <p className="cp-eyebrow">Client Portal</p>
        <h1 className="cp-title">My Account</h1>
      </div>

      {/* Profile section */}
      <div className="cp-section" style={{marginBottom:'20px'}}>
        <div className="cp-section-header">
          <h2 className="cp-section-title">Profile</h2>
          {!isEditing && <button className="cp-btn-secondary" style={{padding:'7px 16px',fontSize:'0.875rem'}} onClick={handleEditToggle}>Edit</button>}
        </div>
        <div className="cp-section-body">
          {!isEditing ? (
            <div className="cp-meta-row" style={{flexDirection:'column',gap:'16px',padding:0}}>
              <div className="cp-meta-item">
                <span className="cp-meta-label">Name</span>
                <span className="cp-meta-value">{userDetails.firstName} {userDetails.lastName}</span>
              </div>
              <div className="cp-meta-item">
                <span className="cp-meta-label">Email</span>
                <span className="cp-meta-value">{userDetails.email}</span>
              </div>
              <div className="cp-meta-item">
                <span className="cp-meta-label">Description</span>
                <span className="cp-meta-value" style={{fontWeight:400,fontFamily:'var(--font-body)'}}>{userDetails.description || '—'}</span>
              </div>
            </div>
          ) : (
            <>
              <div className="cp-form-group"><label>First Name</label><input type="text" name="firstName" value={userDetails.firstName} onChange={handleChange}/></div>
              <div className="cp-form-group"><label>Last Name</label><input type="text" name="lastName" value={userDetails.lastName} onChange={handleChange}/></div>
              <div className="cp-form-group"><label>Email</label><input type="email" name="email" value={userDetails.email} readOnly/></div>
              <div className="cp-form-group"><label>Description</label><textarea name="description" value={userDetails.description} onChange={handleChange}/></div>
              <div className="cp-btn-row">
                <button className="cp-btn-primary" onClick={handleSave}>Save</button>
                <button className="cp-btn-secondary" onClick={handleEditToggle}>Cancel</button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Change password section */}
      <div className="cp-section" style={{marginBottom:'24px'}}>
        <div className="cp-section-header"><h2 className="cp-section-title">Change Password</h2></div>
        <div className="cp-section-body">
          <div className="cp-form-group">
            <label htmlFor="password">New Password</label>
            <input type="password" id="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Enter new password"/>
          </div>
          <div className="cp-btn-row">
            <button className="cp-btn-secondary" onClick={handlePasswordChange}>Update Password</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
